import VoiceMessage from './VoiceMessage';
import ImageMessage from './ImageMessage';
import TextMessage from './TextMessage';
import VideoMessage from './VideoMessage';
import MusicMessage from './MusicMessage';
import CardMessage from './CardMessage';
import CheckInMessage from './CheckInMessage';
import RedpackMessage from './RedpackMessage';
import RewardMessage from './RewardMessage';
import FileMessage from './FileMessage';
import ShareCardMessage from './ShareCardMessage';
import ErrorMessage from './ErrorMessage'

export {
    VoiceMessage,
    ImageMessage,
    VideoMessage,
    TextMessage,
    MusicMessage,
    CardMessage,
    CheckInMessage,
    RedpackMessage,
    RewardMessage,
    FileMessage,
    ShareCardMessage,
    ErrorMessage,
}




// WEBPACK FOOTER //
// ./src/components/messages/index.js